// extracted by mini-css-extract-plugin
module.exports = {"info_card":"InfoCard_info_card__npriC","content":"InfoCard_content__fZ2Ic","displayRides":"InfoCard_displayRides__21f7V","ridesBanner":"InfoCard_ridesBanner__rI6Pc"};